import { styled } from "styled-components";

export const SideTitle = styled.div`
  text-align: left;
`;
